<template>
  <a id="farms-link" :href="FARM_URL" rel="noopener noreferrer" target="_blank">
    <div class="farm-banner" @click="trackLink">
      <div class="farm-banner__content">
        <img
          alt="farm-left-image"
          class="farm-banner__left-img"
          src="@/assets/farms.svg"
        />
        <div class="farm-banner__section">
          <div class="farm-banner__subtitle">{{ $t('swap.newFarmsWith') }}</div>
          <div class="farm-banner__title">60%+ {{ $t('pools.apr') }}</div>
        </div>
        <img
          alt="farm-left-image"
          class="farm-banner__right-img"
          src="@/assets/farms.svg"
        />
      </div>
    </div>
  </a>
</template>

<script lang="ts" setup>
import { FARM_URL } from '@/constants';
import { EMixpanelEventNames, EMixpanelProvideKeys } from '@/types/enums';
import { inject } from 'vue';
import { Track } from '@/types';

const track = inject(EMixpanelProvideKeys.Track) as Track;

const trackLink = () => {
  track(EMixpanelEventNames.BannerGoToFarms);
};
</script>

<style lang="scss" scoped>
$xxl-resolution: 2450px;
$s-resolution: 768px;

.farm-banner {
  position: relative;
  overflow: hidden;
  z-index: 12;

  width: 100%;
  height: 84px;

  border-radius: 14px;

  backdrop-filter: blur(7.5px);
  -webkit-backdrop-filter: blur(7.5px);

  background: linear-gradient(
      90deg,
      rgba(143, 88, 255, 0.2) 0%,
      rgba(143, 88, 255, 0) 100%
    ),
    linear-gradient(0deg, rgba(185, 141, 255, 0.1), rgba(185, 141, 255, 0.1));

  &__content {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 20px 20px 10px;

    @media screen and (max-width: $xxl-resolution) {
      justify-content: left;
    }
  }

  &__right-img {
    position: absolute;
    top: 20px;
    right: -25px;
    transform: rotate(330deg) scaleX(-1);
    width: 80px;
  }

  &__left-img {
    position: absolute;
    top: 20px;
    left: -25px;
    transform: rotate(30deg);
    width: 80px;
  }

  &__subtitle {
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    color: #ffffff;
    letter-spacing: 0em;
    text-align: left;

    @media screen and (max-width: $s-resolution) {
      font-size: 14px;
    }
  }

  &__title {
    font-size: 26px;
    font-weight: 900;
    line-height: 34px;
    letter-spacing: -0.0043em;
    text-align: left;
    background: -webkit-linear-gradient(90.99deg, #aa81ff 0%, #c6aaff 103.51%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    @media screen and (max-width: $s-resolution) {
      font-size: 20px;
    }
  }

  &__footer {
    display: flex;
    justify-content: center;
  }

  &__button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 125px;
    border-radius: 12px;

    font-size: 15px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: center;

    @media screen and (max-width: $xxl-resolution) {
      width: 185px;
      margin-right: 1.2rem;
      font-size: 14px;
    }

    @media screen and (max-width: $s-resolution) {
      width: 120px;
      font-size: 12px;
    }
  }

  &__link {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.0008em;
    text-align: left;
    color: #c4a8ff;
  }

  &__close-button {
    position: absolute;
    top: 10px;
    right: 10px;

    i {
      opacity: 0.5;
      cursor: pointer;
    }
  }

  &__overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: var(--background-color);
    z-index: 0;
    top: 0;
    border-radius: 14px;
  }

  &__section {
    @media screen and (max-width: $xxl-resolution) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
  }

  &__separator {
    opacity: 0.15;
  }

  @media screen and (max-width: $xxl-resolution) {
    width: 100%;
  }
}
</style>
